export default function CsQuiz() {
  return (
    <h2>Cs Quiz</h2>
  );
}
